module.exports = __webpack_public_path__ + "static/img/logo.9d79ea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/logo.jpg
// module id = 1ALx
// module chunks = 2